// import { useAppContext } from '../store/AppContext';
import useApi from './useApi';

const useAdministratorsService = () => {
  const { api } = useApi();
  // const [{ adminType }] = useAppContext();

  const getAdministrators = () => api({
    method: 'get',
    url: '/identity-access/v1/establishments/own/establishment-admin-accounts',
  });

  const postUpdateStatus = (accountId, isActive) => {
    const state = isActive ? 'activate' : 'deactivate';
    return api({
      method: 'post',
      url: `/identity-access/v1/establishments/own/establishment-admin-accounts/${accountId}:${state}`,
    });
  };

  return {
    getAdministrators,
    postUpdateStatus,
  };
};

export default useAdministratorsService;
